import React from 'react'
import {FilePond} from 'react-filepond'
import 'filepond/dist/filepond.min.css'
import {API_ROOT} from "../../../../baseUrls";

export default function FileUploaderDialog(props) {
  return (
    <>
    <div className="App">
      <FilePond
        ref={props.filepondRef}
        credits={false}
        files={props.files}
        onupdatefiles={props.setFiles}
        allowMultiple={true}
        maxParallelUploads={1}
        name="fileData"
        server={{
          process: {
            url: `${API_ROOT}/mindfiles/${props.mindfileId}/upload-file`,
            headers: {'X-CSRF-Token': props.authenticityToken},
            ondata: (formData) => {
              formData.append("folder_id", props.selectedFolder.id);
              return formData;
            },
            onload: (response) => {
              try{
                let item = JSON.parse(response);
                props.onUploadComplete(item);
                return item.id;
              }catch(e){
                console.log("unexpected upload response", response, e);
              }
            },
          },
          revert: null
        }}
        onactivatefile={(file) => {
          if(file.status === 5){
            props.tagFile(file);
          }
        }}
        beforeRemoveFile={(file) => {
          if(file.status === 5){
            return new Promise((resolve, reject) => props.tagFile(file));
          }
          return false;
        }}
        iconRemove='<svg viewBox="-4 -4 32 32"><path d="M17 12c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm1.65 7.35L16.5 17.2V14h1v2.79l1.85 1.85-.7.71zM18 3h-3.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H6c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h6.11c-.59-.57-1.07-1.25-1.42-2H6V5h2v3h8V5h2v5.08c.71.1 1.38.31 2 .6V5c0-1.1-.9-2-2-2zm-6 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"></path></svg>'
        labelIdle='Drag & Drop your files or <span class="filepond--label-action">Browse</span>'
        labelTapToUndo=''
        labelTapToCancel=''
        labelFileProcessingComplete={"Upload Complete, Tap to tag"}
        styleButtonRemoveItemPosition={'background-color:#fff;'}
      />
    </div>

    </>
  )
}
